import React from "react";
import { withRouter } from "react-router-dom";
import { readSession } from "../../helpers/session";
import AccountInfo from "./AccountInfo";
import api from "../../common/lib/api";
import Session from "./Session";
import { Tabs, Tab } from "@blueprintjs/core";
import { ApiWrapped } from "./ApiWrapped";
import Location from "./Location";
import { useHistory } from "react-router-dom";

export default withRouter(function Page({
  match: {
    params: { key, tab },
  },
}) {
  const session = readSession(key);
  const history = useHistory();
  
  api.login(session.token, session.token);
  
  return (
    <>
      <Session session={key} sessionData={session} />
      <h1>{`Hi ${session.firstName} ${session.lastName}`}</h1>
      <ApiWrapped
        token={session.token}
        endpoint="/devices"
        renderCallback={({ state, setState }) => {
          return (
            <Tabs
              renderActiveTabPanelOnly
              large
              onChange={(newTab) => {
                history.push(`/web/session/${key}/${newTab}`);
              }}
              selectedTabId={tab || "account"}
            >
              <Tab
                id="account"
                title="My Account"
                panel={<AccountInfo session={key} token={session.token} />}
              />
              {state.data.map((device) => (
                <Tab
                  key={device.deviceUuid}
                  id={device.deviceUuid}
                  title={device.name}
                  panel={<Location token={session.token} device={device} />}
                />
              ))}
            </Tabs>
          );
        }}
      />
    </>
  );
});
